import { render, staticRenderFns } from "./ChipMenu.vue?vue&type=template&id=62e17389"
import script from "./ChipMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ChipMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports